// "Do you have a domain?" in the check form (check-form.ejs). The checked
// option decides which fields count: data-needs-url shows and requires the
// site address, otherwise the address is disabled (not sent, not validated)
// and the description becomes required, because it is the only information
// about the project. The option hints follow the checked option.
export function bindDomainChoice(root: ParentNode = document): void {
    root.querySelectorAll<HTMLFieldSetElement>('[data-domain-choice]').forEach((choice) => {
        const form = choice.form!;
        const url = form.querySelector<HTMLInputElement>('[name="url"]')!;
        const message = form.querySelector<HTMLTextAreaElement>('[name="message"]')!;
        const optionalMark = form.querySelector<HTMLElement>('[data-optional-mark]')!;
        const options = [...choice.querySelectorAll<HTMLInputElement>('input[type="radio"]')];
        const update = () => {
            const checked = options.find((option) => option.checked)!;
            const needsUrl = checked.hasAttribute('data-needs-url');
            url.closest<HTMLElement>('.kt-field')!.hidden = !needsUrl;
            url.disabled = !needsUrl;
            message.required = !needsUrl;
            optionalMark.hidden = !needsUrl;
            for (const option of options) {
                const hint = choice.querySelector<HTMLElement>(`[data-hint-for="${option.id}"]`);
                if (hint) hint.hidden = option !== checked;
            }
        };
        options.forEach((option) => option.addEventListener('change', update));
        // form.reset() after a successful send restores the default option.
        form.addEventListener('reset', () => setTimeout(update));
        update();
    });
}
